import { render, staticRenderFns } from "./ManageUsersPage.vue?vue&type=template&id=195e402c&"
import script from "./ManageUsersPage.vue?vue&type=script&lang=js&"
export * from "./ManageUsersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports